import React from 'react';
import { FormProps } from 'util/Form';
import PostalCodeFormItem from 'components/shared/AddressFormSection/PostalCodeFormItem';

interface PostalCodeQuestionFormItemProps extends FormProps {
  fieldName: string;
  addressFieldName: string;
  countryFieldName?: string;
}

const PostalCodeQuestionFormItem: React.FunctionComponent<PostalCodeQuestionFormItemProps> = ({
  fieldName,
  addressFieldName,
  countryFieldName,
  required,
  disabled,
}) => {
  return (
    <PostalCodeFormItem
      fieldName={fieldName}
      addressFieldName={addressFieldName}
      countryFieldName={countryFieldName}
      required={required}
      disabled={disabled}
      label=""
      generateControlName={false}
    />
  );
};
export default PostalCodeQuestionFormItem;
